import YouTubeIcon from '@mui/icons-material/YouTube';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, TextField, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { CommonHelper } from 'src/utils/commonHelper';
import { useTranslation } from 'react-i18next';

const TwitterAppSumoAuthorizationModal = ({
  handlTwitterOauthToken,
  handleClose,
  handleInputChange,
  appKey,
  appSecretKey,
  accessToken,
  accessSecretToken,
  isLoadingOn,
}) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleConnectTwitter = () => {
    handlTwitterOauthToken();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography gutterBottom variant="h4">
          {translate('common.authorize')} {CommonHelper.GetAppName()}
          {translate('integration.twitter.access_your_account')}?
        </Typography>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          backgroundColor: 'whitesmoke',
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '20px',
          }}
        >
          {isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography sx={{ fontSize: '14px', color: 'gray' }}>
                {translate('integration.twitter.watch_twitter_video')}
              </Typography>
              {(!isCustomDomain || isPortalAdmin) && <Button
                variant="outlined"
                startIcon={<YouTubeIcon />}
                onClick={() => window.open('https://www.youtube.com/watch?v=bZz8_Bkjv-A', '_blank')}
                color="primary"
              >
                {translate('common.tutorial')}
              </Button>}
            </Box>
          ) : (
            <>
              <Typography sx={{ fontSize: '14px', color: 'gray' }}>
                {translate('integration.twitter.watch_twitter_video')}
              </Typography>
              {(!isCustomDomain || isPortalAdmin) && <Button
                variant="outlined"
                startIcon={<YouTubeIcon />}
                onClick={() => window.open('https://www.youtube.com/watch?v=bZz8_Bkjv-A', '_blank')}
                color="primary"
              >
                {translate('common.tutorial')}
              </Button>}
            </>
          )}
        </Box>
        <CardContent
          sx={{
            p: 0,
            color: 'grey.800',
          }}
        >
          <TextField
            name="appKey"
            value={appKey}
            label={"Consumer Key"}
            fullWidth
            margin="normal"
            onChange={handleInputChange}
          />
          <TextField
            name="appSecretKey"
            value={appSecretKey}
            label={"Consumer Key Secret"}
            fullWidth
            margin="normal"
            onChange={handleInputChange}
          />
          <TextField
            name="accessToken"
            value={accessToken}
            label={translate("common.access_token")}
            fullWidth
            margin="normal"
            onChange={handleInputChange}
          />
          <TextField
            name="accessSecretToken"
            value={accessSecretToken}
            label={translate("common.access_token_secret")}
            fullWidth
            margin="normal"
            onChange={handleInputChange}
          />
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton variant="contained" loading={isLoadingOn} autoFocus onClick={handleConnectTwitter}>
          {translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default TwitterAppSumoAuthorizationModal;
